"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeNexus = exports.writeNewick = void 0;
function writeNewick(tree) {
    let newickStr = '';
    if (tree.root !== undefined)
        newickStr += newickRecurse(tree.root, false) + ';';
    return newickStr;
}
exports.writeNewick = writeNewick;
function writeNexus(tree) {
    let nexusStr = '#NEXUS\n\nbegin trees;\n';
    if (tree.root !== undefined)
        nexusStr +=
            `\ttree tree_1 = [&R] ${newickRecurse(tree.root, true)};` + '\n';
    nexusStr += 'end;';
    return nexusStr;
}
exports.writeNexus = writeNexus;
function newickRecurse(node, annotate) {
    let res = '';
    if (!node.isLeaf()) {
        res += '(';
        for (let i = 0; i < node.children.length; i++) {
            if (i > 0)
                res += ',';
            res += newickRecurse(node.children[i], annotate);
        }
        res += ')';
    }
    if (node.label !== undefined)
        res += `"${node.label}"`;
    if (node.hybridID !== undefined)
        res += `#${node.hybridID}`;
    if (annotate) {
        const keys = Object.keys(node.annotation);
        if (keys.length > 0) {
            res += '[&';
            for (let idx = 0; idx < keys.length; idx++) {
                const key = keys[idx];
                if (idx > 0)
                    res += ',';
                res += `"${key}"=`;
                const value = node.annotation[key];
                if (Array.isArray(value)) {
                    res += `{${String(value.join(','))}}`; // Convert the array to a comma-separated string
                }
                else {
                    res += `"${String(value)}"`; // Explicitly convert the value to a string
                }
            }
            res += ']';
        }
    }
    if (node.branchLength !== undefined)
        res += `:${node.branchLength}`;
    else
        res += ':0.0';
    return res;
}
